import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform, inject } from '@angular/core';

/**
 * This pipe is used to bypass Angular's Sanitizer and prevent it from throwing errors
 * when we must bind html, styles, or URLs to guarded HTML attributes such as src.
 * This is to be used only by necessity and when sure that the content being bound
 * can be wholly trusted.
 * @param content The bound variable containing the content.
 * @param type The type of content being binded.
 */

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafePipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {}

  public transform(content: string, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(content);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(content);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(content);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(content);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(content);
      default:
        throw new Error(`Invalid safe type specified: ${type}.`);
    }
  }
}
